import React from "react";

import { dialogContentStyle } from "./styles";

const CancelAlreadyCompleted = () => {
    return <p css={dialogContentStyle}>취소가 완료된 내역입니다.</p>;
};

export default CancelAlreadyCompleted;
